import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-900 to-slate-950" data-id="element-139">
      <div className="max-w-3xl mx-auto" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="glass-panel p-8 md:p-12 rounded-3xl border-green-500/30 text-center relative overflow-hidden" data-id="element-141">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-green-500/5 blur-[100px] pointer-events-none" data-id="element-142" />

          <div className="relative z-10" data-id="element-143">
            <motion.div initial={{
            rotate: -10,
            scale: 0.8
          }} whileInView={{
            rotate: 0,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            type: 'spring',
            stiffness: 200
          }} className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-500/20 text-green-400 mb-6" data-id="element-144">
              <ShieldCheck className="w-10 h-10" data-id="element-145" />
            </motion.div>

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-146">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="space-y-4 text-lg text-slate-300 mb-8" data-id="element-147">
              <p data-id="element-148">Abrís los tomos. Los leerás antes del viaje o durante.</p>
              <p className="font-semibold text-white" data-id="element-149">
                Si en 7 días no es lo que esperabas: devolución del 100% sin
                formularios, sin drama.
              </p>
            </div>

            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/80 border border-slate-700 text-sm font-medium text-slate-400" data-id="element-150">
              Tasa de devoluciones:{' '}
              <span className="text-green-400 font-bold" data-id="element-151">menos del 1%.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}